<div id="cutomer-information-screen" (window:orientationchange)="changeOrientation($event)"
    [ngStyle]="{'height.px':divHeight1}">
    <div class="row" [ngStyle]="{'height.px':divHeight1}">
        <div class="col-md-6" id="progress-tracker" [ngStyle]="{'height.px':divHeight1}">
            <div id="heading">
                <h1 class="customH1" *ngIf="showHeading">
                    <strong [innerHTML]="cfetLabels.cfet_customer_information.heading"></strong>
                </h1>
                <h1 id="step-done-heading" *ngIf="showStepCompleteHeading">
                    <strong>{{cfetLabels.cfet_customer_eligibility.step_one_complete_heading}}</strong>
                </h1>
                <h1 id="step-done-subheading" *ngIf="showStepCompleteHeading">
                    <strong>{{cfetLabels.cfet_customer_eligibility.step_one_complete_subheading}}</strong>
                </h1>
            </div>
            <div id="all-track">
                <div class="row" id="track1">
                    <div class="col-lg-1" id="circle">
                        <button [ngClass]="stepOneSelected ? 'btn1-selected' : 'btn1'" id="btn1-desc">
                            <p id="btn-no">&#10003;</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepOneSelected ? 'static-text1-selected' : 'static-text'" id="static-text-decs">
                            {{cfetLabels.cfet_customer_eligibility.eligibility}}
                            <em *ngIf="showDesktopEditButton" class="icon-misc-penL" role="img" aria-label="Edit Button"
                                id="icon-role" tabindex="0" (click)="goToEligibility($event)"
                                (keyup)="goToEligibility($event)"></em>
                            <em *ngIf="showMobileEditButton" class="icon-misc-penL" role="img" aria-label="Edit Button"
                                id="icon-mobile-role" tabindex="0" (click)="goToEligibility($event)"
                                (keyup)="goToEligibility($event)"></em>
                        </p>
                    </div>
                </div>
                <div id="show-workplace-section" *ngIf="showWorkPlaceSection">
                    <div class="row">
                        <div class="col-md-10 role-mobile-max">
                            <div class="selected-role">
                                <label for="selected-role" class="selected-role-heading">{{selectedRole}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="dividercomp section">
                        <div class="row" id="action-divider"></div>
                    </div>
                    <div class="row">
                        <div class="col-md-10 role-mobile-max">
                            <div class="selected-workplace">
                                <label for="selected-workplace-name"
                                    class="selected-workplace-name">{{selectedWorkPlace}}</label>
                                <p class="selected-workplace-address">{{selectedAddress}}, {{selectedCity}},
                                    {{selectedStateInWorkplace}} {{selectedZipInWorkplace}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <span [ngClass]="stepOneDone? 'solid-line': 'dashed-line'" id="vertical-line1"></span>
                <div class="row" id="track2">
                    <div class="col-lg-1" id="circle">
                        <button id="btn2-desc" [ngClass]="stepTwoSelected ? 'btn2-selected' : 'btn1' "
                            [disabled]="disableStep" (click)="stepTwo()">
                            <p *ngIf="stepTwoIcon" id="btn-no">2</p>
                            <p *ngIf="stepTwoDone" id="btn-no">&#10003;</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepTwoSelected ? 'static-text2-selected' : 'static-text'" (click)="stepTwo()"
                            (keyup)="stepTwo()" id="static-text-desc2">
                            {{cfetLabels.cfet_customer_eligibility.information}}</p>
                    </div>
                </div>
                <div id="vertical-line1" id="vertical-line2"></div>
                <div class="row" id="track3">
                    <div class="col-lg-1" id="circle">
                        <button id="btn3-desc" [ngClass]="stepThreeSelected ? 'btn3-selected' : 'btn1' "
                            [disabled]="disableStep">
                            <p *ngIf="stepThreeIcon" id="btn-no">3</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepThreeSelected ? 'static-text3-selected' : 'static-text'"
                            id="static-text-desc3">{{cfetLabels.cfet_customer_eligibility.profile}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6" id="form-component-section">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                    <app-customer-information-form [selectedWorkPlace]="selectedWorkPlace"
                        (hideEditButton)="hideEditButton($event)"
                        (goToInstantVerification)="goToInstantVerification1($event)"
                        (setSessionTimeout)="setSessionTimeout($event)" (showCancelModal)="cancelModal($event)">
                    </app-customer-information-form>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>
    </div>
    <div [ngClass]="showInactivityModal ? 'open-inactivity-modal' : ''">
        <app-customer-inactivity-modal [openModal]="openInactivityModal"
            (closeInactivityModal)="closeInactivityModal($event)">
        </app-customer-inactivity-modal>
    </div>
    <div [ngClass]="showCancelModal ? 'cancel-modal' : 'hide-cancel-modal'">
        <app-cancel-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)"
            (setNewSession)="setSessionTimeout($event)">
        </app-cancel-modal>
    </div>
</div>